"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchFormItemWrapper = exports.SkillTagSelect = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const antd_1 = require("antd");
exports.SkillTagSelect = (0, styled_components_1.default)(elements_1.Select) `
	width: 100%;
`;
exports.SwitchFormItemWrapper = (0, styled_components_1.default)(antd_1.Form.Item) `
	flex-direction: row-reverse !important;
	display: inline-flex;
	align-items: center;
	.ant-form-item-label {
		padding: 0 0.5rem;
	}
`;
